import Button from "@/components/Button";
import Modal, { MEDIUM_MODAL_WIDTH } from "@/dsComponents/Modal";
import rem from "@/utils/rem";
import { ModalBody, ModalFooter, ModalFooterRight, ModalHeader, ModalTitle } from "@dextech-ai/dex-design-system";
import { InfoOutlined } from "@dextech-ai/dex-design-system/icons";
import PropTypes from "prop-types";

// Yes / No confirmation for approving or rejecting a data request (participant dashboard, request
// list, use-case dashboard and view). Legacy sized it to its content: the longer reject message
// rendered at the legacy medium width, the approve one at the DS default.
const RequestConfirmationModal = ({ visible, hide, title, message, isReject, onConfirm, yesTestId, noTestId }) => (
	<Modal width={isReject ? MEDIUM_MODAL_WIDTH : undefined} visible={visible} close={hide}>
		<ModalHeader icon={<InfoOutlined data-ds-color="primary-dark" />}>
			<ModalTitle>{title}</ModalTitle>
		</ModalHeader>
		<ModalBody>
			{message && (
				<div style={{ fontSize: rem(14), textAlign: "center" }}>
					{message}
				</div>
			)}
		</ModalBody>
		<ModalFooter>
			<ModalFooterRight>
				<Button
					ghost
					text="Yes"
					submit={() => {
						hide();
						onConfirm();
					}}
					data-testid={yesTestId}
				/>
				<Button text="No" submit={() => hide()} data-testid={noTestId} />
			</ModalFooterRight>
		</ModalFooter>
	</Modal>
);

RequestConfirmationModal.propTypes = {
	visible: PropTypes.bool,
	hide: PropTypes.func.isRequired,
	title: PropTypes.node,
	message: PropTypes.node,
	isReject: PropTypes.bool,
	onConfirm: PropTypes.func.isRequired,
	yesTestId: PropTypes.string,
	noTestId: PropTypes.string,
};

export default RequestConfirmationModal;
